import React, { Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

const Footer = () => {
    return (
        <Fragment>
            <section className='pb-6 bg-[#F8F8F8]'>
                <Container className='relative'>
                    <Row className='mb-10'>
                        <Col className='mb-4 mb-lg-0' lg={3}>
                            <div className="mb-3">
                                <img src="./assets/pantria/web_logo.png" alt="Pantria" className="w-auto object-contain h-7" />
                            </div>
                            <p className='text__16'>Connecting food lovers with local home cooks across the UK.</p>
                        </Col>
                        <Col className='col-6 mb-4 mb-lg-0' lg={{ span: 2, offset: 1 }}>
                            <h5 className='font-medium text__16 mb-3 text-[#A3A3A3]'>Navigate</h5>
                            <div className="flex flex-wrap gap-3 font-medium text__16">
                                <a href="#about" className='inline-block w-full text-Mblack'>About Us</a>
                                <a href="#contact" className='inline-block w-full text-Mblack'>Contact Us</a>
                            </div>
                        </Col>
                        <Col className='col-6 mb-4 mb-lg-0' lg={2}>
                            <h5 className='font-medium text__16 mb-3 text-[#A3A3A3]'>Link</h5>
                            <div className="flex flex-wrap gap-3 font-medium text__16">
                                <NavLink to="/privacy" className='inline-block w-full text-Mblack'>Privacy Policy</NavLink>
                                <NavLink to="/terms" className='inline-block w-full text-Mblack'>Terms & Conditions</NavLink>
                                {/* <NavLink to="/faq" className='inline-block w-full text-Mblack'>FAQ</NavLink> */}
                            </div>
                        </Col>
                        <Col className='mb-4 mb-lg-0' lg={4}>
                            <h5 className='font-medium text__16 mb-3'>Newsletter</h5>
                            <p className='text__16 mb-3'>Get in touch:</p>
                            <a href="mailto:hello@pantria.co" className='text__16 text-Mblack font-medium'>hello@pantria.co</a>
                        </Col>
                    </Row>

                    <div className="relative flex flex-wrap lg:flex-nowrap items-center justify-center md:justify-between gap-y-2 gap-x-4 bg-[#F5F5F5] px-4 py-2 rounded-full">
                        <p className='text__16 text-[#A3A3A3]'>© 2025 Quenra Ltd</p>

                        <div className="flex justify-center items-center gap-3 w-auto">
                            <a href="https://instagram.com/pantria.co" target="_blank" rel="noopener noreferrer">
                                <img src="./assets/images/sos (3).svg" alt="Instagram" />
                            </a>
                            <a href="https://facebook.com/pantria" target="_blank" rel="noopener noreferrer">
                                <img src="./assets/images/sos (4).svg" alt="Facebook" />
                            </a>
                        </div>
                    </div>
                </Container>
            </section>
        </Fragment>
    )
}

export default Footer
